import type { GLTF } from "three/examples/jsm/Addons.js";
import { togglePartMaterial, toggleVisibility } from "@/features/model-renderer/utils/configuration.ts";
import type { SmartNumberMapping } from "@/features/sub-families/types";
import { getPartNumberFromDescriptor } from "@/features/sub-families/utils/parts.ts";
import { SmartNumberDescriptor, type SmartNumberDescriptorKey } from "@/types";
import { typedObjectEntries } from "@/utils/types.ts";

export function renderModelByConfiguration(model: GLTF, smartNumberMapping: SmartNumberMapping) {
    for (const [descriptorKey, configCode] of typedObjectEntries(smartNumberMapping)) {
        const partNo = getPartNumberFromDescriptor(descriptorKey);

        // When a part number was found, it means the configCode is a colour code, hence we need to update the materials
        if (partNo !== null) {
            void togglePartMaterial(model, configCode, partNo);
        } else {
            // Update the visibility of the meshes
            const modelAttribute = DESCRIPTOR_KEY_TO_MODEL_ATTRIBUTE[descriptorKey] ?? null;
            if (!modelAttribute) continue; // Nothing needs to be done for values that we cannot map onto the model

            toggleVisibility(model, modelAttribute, configCode);
        }
    }
}

const DESCRIPTOR_KEY_TO_MODEL_ATTRIBUTE: Partial<Record<SmartNumberDescriptorKey, string>> = {
    [SmartNumberDescriptor.Accessory]: "lightdistribution",
};
